import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "../../style/login.css";
import curve from "../../assets/Vector-curve.png";

import img1 from "../../assets/2025/1.jpg";
import img2 from "../../assets/2025/2.jpg";
import img3 from "../../assets/2025/3.jpg";
import img4 from "../../assets/2025/4.jpg";
import img5 from "../../assets/2025/5.jpg";
import img6 from "../../assets/2025/6.jpg";
import img7 from "../../assets/2025/7.jpg";
import img10 from "../../assets/2025/10.jpg";
import img11 from "../../assets/2025/11.jpg";
import img12 from "../../assets/2025/12.jpg";
import img13 from "../../assets/2025/13.jpg";
import img14 from "../../assets/2025/14.jpg";
import img17 from "../../assets/2025/17.jpg";
import img18 from "../../assets/2025/18.jpg";
import img19 from "../../assets/2025/19.jpg";
import img22 from "../../assets/2025/22.jpg";
import img24 from "../../assets/2025/24.jpg";
import img25 from "../../assets/2025/25.jpg";
import img26 from "../../assets/2025/26.jpg";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useLoading } from "../../context/SideContext";
import { useAlert } from "../../context/AlertMessageContext";
import Alerts from "../../components/Alert";

import Spinner from "react-bootstrap/Spinner";

const Login = () => {
  const { setMessage } = useAlert();
  const [open, setOpen] = useState(false);
  const [variant, setVariant] = useState("danger");
  const navigate = useNavigate();
  const [roles, setRoles] = useState("student");
  const [email, setEmail] = useState("");
  const [regNo, setRegNo] = useState("");
  const [newRegNo, setNewRegNo] = useState("");
  const [password, setPassword] = useState();
  const [register, setRegister] = useState(false);
  const [isRegenMode, setIsRegenMode] = useState(false);
  const [regenRegNo, setRegenRegNo] = useState("");
  const [regenEmail, setRegenEmail] = useState("");
  const [regStatus, setRegStatus] = useState("open");
  const [regHeadline, setRegHeadline] = useState("Registrations are now open!");
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(true);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 760 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  const { setToken, setIsuserloggedin, setRole } = useAuth();
  const { loading, setLoading } = useLoading();

  const fetchRegistrationStatus = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/auth/registration-status`
      );
      if (res.data && res.data.success) {
        const status = res.data.status || (res.data.is_open ? "open" : "closed");
        setRegStatus(status);
        setIsRegistrationOpen(status === "open");
        setRegHeadline(
          res.data.message ||
            (status === "open"
              ? "Registrations are now open!"
              : status === "upcoming"
              ? "Registrations will open soon!"
              : "Registrations are now closed!")
        );
        if (status !== "open") {
          setRegister(false);
        }
      }
    } catch (err) {
      console.log("Could not load registration status:", err);
    }
  };

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (loading) return;

    if (roles === "student" && regStatus !== "open") {
      setOpen(true);
      setVariant("danger");
      setMessage(
        regStatus === "upcoming"
          ? "Convocation registrations will open soon. Student login is currently disabled."
          : "Convocation registrations are closed. Student login is currently disabled."
      );
      return;
    }

    setLoading(true);
    let params;
    if (roles === "student") {
      params = { role: roles, reg_no: regNo, password: password };
    } else {
      params = { role: roles, email: email, password: password };
    }
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_API_BASE}/auth/login`,
        params
      );
      console.log(result);
      if (result.data.success && result.data.token) {
        const verifiedRole = result.data.role || roles;
        const stringifieddata = JSON.stringify({
          loginstatus: true,
          clienttoken: result.data.token,
          loginRole: verifiedRole,
        });
        localStorage.setItem("login", stringifieddata);
        setMessage("Logged In Successfully");
        setToken(result.data.token);
        setIsuserloggedin(true);
        setRole(verifiedRole);

        if (verifiedRole === "admin") {
          navigate("/admin");
        } else {
          navigate("/");
        }
      }
    } catch (e) {
      setMessage(e?.response?.data?.error || e.message || "Failed to connect to backend server");
      setVariant("danger");
      setOpen(true);
      console.log(e);
    }
    setLoading(false);
  };

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();
    if (!isRegistrationOpen) {
      setOpen(true);
      setVariant("danger");
      setMessage("Registrations are currently closed by the administration.");
      return;
    }

    if (!newRegNo || !newRegNo.trim()) {
      setOpen(true);
      setVariant("danger");
      setMessage("Please enter your Registration Number.");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/auth/register`,
        {
          role: "student",
          reg_no: newRegNo.trim(),
        }
      );
      setRegister(false);
      setIsRegenMode(false);
      setOpen(true);
      setVariant("success");
      setMessage(res.data?.message || "Registered Successfully! Check email for login credentials");
      setRegNo(newRegNo.trim());
      setNewRegNo("");
    } catch (error) {
      setOpen(true);
      setVariant("danger");
      const errMsg = error?.response?.data?.error || error.message || "Failed to connect to backend server";
      setMessage(errMsg);
      // If user is already registered, automatically pre-fill the regen form registration number
      if (errMsg.toLowerCase().includes("already registered")) {
        setRegenRegNo(newRegNo.trim());
      }
      console.log(error);
    }
    setLoading(false);
  };

  const handleRegenSubmit = async (e) => {
    e.preventDefault();
    if (!isRegistrationOpen) {
      setOpen(true);
      setVariant("danger");
      setMessage(
        regStatus === "upcoming"
          ? "Password regeneration is currently disabled as registrations will open soon."
          : "Password regeneration is currently disabled as registrations are closed."
      );
      return;
    }
    if (!regenRegNo || !regenRegNo.trim() || !regenEmail || !regenEmail.trim()) {
      setOpen(true);
      setVariant("danger");
      setMessage("Please enter both your Registration Number and registered Student Email ID.");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/auth/student-regenerate-password`,
        {
          reg_no: regenRegNo.trim(),
          email: regenEmail.trim(),
        }
      );
      setOpen(true);
      setVariant("success");
      setMessage(res.data?.message || "Password regenerated successfully! Please check your email.");
      setIsRegenMode(false);
      setRegister(false);
      setRegNo(regenRegNo.trim());
      setRegenRegNo("");
      setRegenEmail("");
    } catch (error) {
      setOpen(true);
      setVariant("danger");
      setMessage(error?.response?.data?.error || error.message || "Failed to regenerate password");
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    localStorage.clear();
    setIsuserloggedin(false);
    fetchRegistrationStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!open) return;
    const timer1 = setTimeout(() => {
      setOpen(false);
      setMessage("");
    }, 6000);
    return () => {
      clearTimeout(timer1);
    };
  }, [open, setMessage]);

  return (
    <>
      {open ? (
        <Alerts
          variant={variant}
          onClose={() => {
            setOpen(false);
            setMessage("");
          }}
        />
      ) : null}
      <div className='login-full'>
        <div className='carousel-login'>
          <Carousel
            responsive={responsive}
            showDots={false}
            arrows={false}
            autoPlay
            autoPlaySpeed={3000}
            infinite
            pauseOnHover={false}
          >
            <div>
              <img src={img1} alt='' />
            </div>
            <div>
              <img src={img2} alt='' />
            </div>
            <div>
              <img src={img3} alt='' />
            </div>
            <div>
              <img src={img4} alt='' />
            </div>
            <div>
              <img src={img5} alt='' />
            </div>
            <div>
              <img src={img6} alt='' />
            </div>
            <div>
              <img src={img7} alt='' />
            </div>
            <div>
              <img src={img10} alt='' />
            </div>
            <div>
              <img src={img11} alt='' />
            </div>
            <div>
              <img src={img12} alt='' />
            </div>
            <div>
              <img src={img13} alt='' />
            </div>
            <div>
              <img src={img14} alt='' />
            </div>
            <div>
              <img src={img17} alt='' />
            </div>
            <div>
              <img src={img18} alt='' />
            </div>
            <div>
              <img src={img19} alt='' />
            </div>
            <div>
              <img src={img22} alt='' />
            </div>
            <div>
              <img src={img24} alt='' />
            </div>
            <div>
              <img src={img25} alt='' />
            </div>
            <div>
              <img src={img26} alt='' />
            </div>
          </Carousel>
        </div>

        <div className='login-txt'>
          <div className='all-txt'>
            <h1
              style={{
                color:
                  regStatus === "open"
                    ? "#198754"
                    : regStatus === "upcoming"
                    ? "#d97706"
                    : "#dc2626",
                fontSize: "2.2rem",
                fontWeight: 700,
                transition: "color 0.3s ease",
              }}
            >
              {regHeadline}
            </h1>
      
            {isRegenMode ? (
              <>
                <p style={{ marginTop: "0.5rem", color: "#555", fontSize: "14px", lineHeight: "1.4" }}>
                  Please enter your <strong>Registration Number</strong> and official <strong>Student Email ID</strong> (@muj.manipal.edu). A new login password will be generated and emailed to you.
                </p>
                <form onSubmit={handleRegenSubmit}>
                  <div className='container'>
                    <input
                      type='text'
                      placeholder='Enter Registration No'
                      value={regenRegNo}
                      disabled={!isRegistrationOpen}
                      onChange={(e) => setRegenRegNo(e.target.value)}
                      style={
                        !isRegistrationOpen
                          ? { backgroundColor: "#f1f5f9", cursor: "not-allowed", opacity: 0.8 }
                          : {}
                      }
                    />
                  </div>
                  <div className='container'>
                    <input
                      type='email'
                      placeholder='Enter Student Email ID'
                      value={regenEmail}
                      disabled={!isRegistrationOpen}
                      onChange={(e) => setRegenEmail(e.target.value)}
                      style={
                        !isRegistrationOpen
                          ? { backgroundColor: "#f1f5f9", cursor: "not-allowed", opacity: 0.8 }
                          : {}
                      }
                    />
                  </div>

                  {loading ? (
                    <div
                      className='container sub-btn-container'
                      style={{ textAlign: "center", margin: "1.5rem auto" }}
                    >
                      <Spinner
                        animation='border'
                        role='status'
                        style={{
                          margin: "1.5rem auto",
                          font: "1.5rem",
                        }}
                      />
                    </div>
                  ) : (
                    <div className='container sub-btn-container'>
                      <button
                        className='btn-all login-btn'
                        type='submit'
                        disabled={!isRegistrationOpen}
                        title={
                          !isRegistrationOpen
                            ? regStatus === "upcoming"
                              ? "Password regeneration is disabled because registrations will open soon"
                              : "Password regeneration is disabled because registrations are closed"
                            : "Regenerate Password"
                        }
                        style={{
                          backgroundColor: !isRegistrationOpen ? "#94a3b8" : "#e06d15",
                          borderColor: !isRegistrationOpen ? "#cbd5e1" : "transparent",
                          color: !isRegistrationOpen ? "#f8fafc" : "#fff",
                          cursor: !isRegistrationOpen ? "not-allowed" : "pointer",
                          opacity: !isRegistrationOpen ? 0.7 : 1,
                          transition: "all 0.2s ease",
                        }}
                      >
                        {!isRegistrationOpen ? "Registration Closed" : "Regenerate Password"}
                      </button>
                    </div>
                  )}
                </form>

                {!isRegistrationOpen && (
                  <div
                    style={{
                      marginTop: "1.2rem",
                      marginBottom: "0.5rem",
                      padding: "10px 14px",
                      borderRadius: "8px",
                      backgroundColor: regStatus === "upcoming" ? "#fffbeb" : "#fef2f2",
                      border: `1px solid ${regStatus === "upcoming" ? "#fde68a" : "#fecaca"}`,
                      color: regStatus === "upcoming" ? "#b45309" : "#991b1b",
                      fontSize: "13px",
                      textAlign: "center",
                      fontWeight: 600,
                    }}
                  >
                    {regStatus === "upcoming"
                      ? "Password regeneration is disabled because registrations will open soon."
                      : "Password regeneration is disabled because convocation registrations are closed."}
                  </div>
                )}

                <p
                  className='login-p'
                  onClick={() => {
                    setIsRegenMode(false);
                    setRegister(true);
                  }}
                >
                  Need to register?
                  <span> Back to Register</span>
                </p>

                <p
                  className='login-p'
                  onClick={() => {
                    setIsRegenMode(false);
                    setRegister(false);
                    setRegNo(regenRegNo);
                  }}
                >
                  Already know your password?
                  <span> Login Now</span>
                </p>
              </>
            ) : !register ? (
              <>
                <form onSubmit={handleSubmit}>
                  <div className='container'>
                    <select
                      name=''
                      id=''
                      value={roles}
                      onChange={(e) => setRoles(e.target.value)}
                    >
                      <option value='student'>Student</option>
                      <option value='department'>Department</option>
                    </select>
                  </div>
                  <div className='container'>
                    {roles === "student" ? (
                      <input
                        type='text'
                        placeholder='Registration No'
                        value={regNo}
                        onChange={(e) => setRegNo(e.target.value)}
                      />
                    ) : (
                      <input
                        type='email'
                        placeholder='Email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    )}
                  </div>
                  <div className='container'>
                    <input
                      type='password'
                      placeholder='Password'
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  {loading ? (
                    <div
                      className='container sub-btn-container'
                      style={{ textAlign: "center", margin: "1.5rem auto" }}
                    >
                      <Spinner
                        animation='border'
                        role='status'
                        style={{
                          margin: "1.5rem auto",
                          font: "1.5rem",
                        }}
                      ></Spinner>
                    </div>
                  ) : (
                    <div className='container sub-btn-container'>
                      {(() => {
                        const isStudentDisabled = roles === "student" && regStatus !== "open";
                        return (
                          <button
                            className='btn-all login-btn'
                            type='submit'
                            disabled={isStudentDisabled}
                            onClick={handleSubmit}
                            style={{
                              cursor: isStudentDisabled ? "not-allowed" : "pointer",
                              backgroundColor: isStudentDisabled ? "#94a3b8" : "#211e1f",
                              borderColor: isStudentDisabled ? "#cbd5e1" : "#000",
                              color: isStudentDisabled ? "#f8fafc" : "#fff",
                              opacity: isStudentDisabled ? 0.65 : 1,
                              transition: "all 0.2s ease",
                            }}
                            title={
                              isStudentDisabled
                                ? regStatus === "upcoming"
                                ? "Student login is disabled because registrations will open soon"
                                : "Student login is disabled because registrations are closed"
                                : "Log in"
                            }
                          >
                            Submit
                          </button>
                        );
                      })()}
                    </div>
                  )}
                </form>

                {regStatus === "open" ? (
                  <p
                    className='login-p'
                    onClick={() => {
                      setRegister(true);
                      setIsRegenMode(false);
                      setNewRegNo("");
                    }}
                  >
                    Don’t have an account?
                    <span> Register Now</span>
                  </p>
                ) : regStatus === "upcoming" ? (
                  <div
                    style={{
                      marginTop: "1.2rem",
                      padding: "10px 14px",
                      borderRadius: "8px",
                      backgroundColor: "#fffbeb",
                      border: "1px solid #fde68a",
                      color: "#b45309",
                      fontSize: "13px",
                      textAlign: "center",
                      fontWeight: 600,
                    }}
                  >
                    Convocation registrations will open soon. Please stay tuned for updates.
                  </div>
                ) : (
                  <div
                    style={{
                      marginTop: "1.2rem",
                      padding: "10px 14px",
                      borderRadius: "8px",
                      backgroundColor: "#fef2f2",
                      border: "1px solid #fecaca",
                      color: "#991b1b",
                      fontSize: "13px",
                      textAlign: "center",
                      fontWeight: 600,
                    }}
                  >
                    Convocation registrations have closed. Registered graduates can log in above.
                  </div>
                )}

                {roles === "student" && (
                  <p
                    className='login-p'
                    style={{ marginTop: "0.4rem", fontSize: "0.95rem" }}
                    onClick={() => {
                      setIsRegenMode(true);
                      setRegenRegNo(regNo);
                    }}
                  >
                    Forgot or didn't receive password?
                    <span style={{ color: "#e06d15", fontWeight: 600 }}> Regenerate Here</span>
                  </p>
                )}
              </>
            ) : (
              <>
                <p style={{ marginTop: "0.5rem", color: "#555" }}>
                  Your password will be generated and sent to your registered student email.
                </p> 
                <form onSubmit={handleRegisterSubmit}>
                  <div className='container'>
                    <input
                      type='text'
                      placeholder='Enter Registration No'
                      value={newRegNo}
                      onChange={(e) => setNewRegNo(e.target.value)}
                    /> 
                  </div>

                  {loading ? (
                    <div
                      className='container sub-btn-container'
                      style={{ textAlign: "center", margin: "1.5rem auto" }}
                    >
                      <Spinner
                        animation='border'
                        role='status'
                        style={{
                          margin: "1.5rem auto",
                          font: "1.5rem",
                        }}
                      ></Spinner>
                    </div>
                  ) : (
                    <div className='container sub-btn-container'>
                       <button
                        className='btn-all login-btn'
                        type='submit'
                        onClick={handleRegisterSubmit}
                        disabled={!isRegistrationOpen}
                        style={{
                          backgroundColor: isRegistrationOpen ? "#e06d15" : "#94a3b8",
                          cursor: isRegistrationOpen ? "pointer" : "not-allowed",
                        }}
                      >
                        {isRegistrationOpen ? "Register" : "Registration Closed"}
                      </button> 
                    </div>
                  )}
                </form>

                <p
                  className='login-p'
                  style={{ marginTop: "0.8rem", fontSize: "0.95rem" }}
                  onClick={() => {
                    setIsRegenMode(true);
                    setRegenRegNo(newRegNo);
                  }}
                >
                  Already registered or didn't receive password?
                  <span style={{ color: "#e06d15", fontWeight: 600 }}> Regenerate Password</span>
                </p>

                <p
                  className='login-p'
                  onClick={() => {
                    setRegister(false);
                    setIsRegenMode(false);
                    setRegNo("");
                  }}
                >
                  Already have an account?
                  <span> Login Now</span>
                </p> 
              </>
            )}
          </div>
        </div>
        <div className='wh-curve'>
          <img src={curve} alt='' className='curve' />
        </div>
      </div>
    </>
  );
};

export default Login;
